<template>
    <div class="main">
        <div class="recruit-block">
            <router-link class="recruit-list" :to="{name: 'RecruitmentInfo',params: {id: c.id}}" v-for="(c,index) in curit" :key="index">
                <p class="recruit-time">{{c.updated_at}}</p>
                <p>{{c.title}}</p>
            </router-link>
            <div style="width: 100%;display: flex;justify-content: center;">
                <el-pagination
                        :page-size="10"
                        @current-change="currentChange"
                        layout="prev, pager, next"
                        :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import * as apis from "@/api/other"
export default {
    data(){
        return {
            curit: [],
          total: 0,
          page: 1
        }
    },
    mounted(){
        this.getInfo();
    },
    filters: {
        formatDate: function(val){
            return val.slice(0,10)
        }
    },
    methods: {
      currentChange(val) {
        this.page = val;
      },
        async getInfo(){
            try{
                let res = await apis.getRecruitContent({ page: this.page });
                if(res.code == 200){
                    this.curit = res.data.data;
                    console.log(this.curit)
                    this.total = res.data.total;
                }
            }catch(e){
                console.log(e)
            }
        }
    }
}
</script>
<style lang="less" scoped>
.recruit-block{
    background: #fff;
    border: 1px solid #ccc;
    padding: 50px 30px;
    margin: 50px 0;
}
.recruit-list{
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    font-size: 20px;
    line-height: 40px;
    color: #000;
    border-bottom: 1px solid #000;
    margin-bottom: 4px;
    &::after{
        display: block;
        content: '';
        position: absolute;
        left: 0;
        bottom: -2px;
        width: 0;
        height: 2px;
        background: #000;
        transition: width 0.5s
    }
}
.recruit-list:hover{
    &::after{
        width: 100%;
        transition: width 0.5s
    }
}
.recruit-time{
    margin-right: 20px;
}
</style>